import React, { Fragment, useState, useReducer, useEffect } from "react";
import { Tab, Nav, Collapse } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

// import SideBar from "./SideBar";
import NavHeader from "./NavHeader";
import Header from "./Header";
// Menus
import { MenuList } from "./Menus";
import { useAuth } from "../../../context/authContext";

const initialState = false;
const reducer = (state, action) => {
  switch (action.type) {
    case "collpase0":
      return { ...state, collpase0: !state.collpase0 };
    case "collpase1":
      return { ...state, collpase1: !state.collpase1 };
    case "collpase2":
      return { ...state, collpase2: !state.collpase2 };
    case "collpase3":
      return { ...state, collpase3: !state.collpase3 };
    default:
      return state;
  }
};

const updateReducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const menuInitial = {
  active: "",
  activeSubmenu: "",
};

// Sample user profile data (to be replaced with actual data from your system)

const Deflayout = ({ title, onClick: ClickToAddEvent }) => {
  const [toggle, setToggle] = useState("");
  const onClick = (name) => setToggle(toggle === name ? "" : name);
  const navigate = useNavigate();
  const [activeMenu, setActiveMenu] = useState(0);
  const [state, dispatch] = useReducer(reducer, initialState);
  const [menustate, setMenustate] = useReducer(updateReducer, menuInitial);
  const [openSidebar, setOpenSidebar] = useState(false);
  const [closeSidebar, setCloseSidebar] = useState(0);
  const { user } = useAuth();
  const [filteredMenuList, setFilteredMenuList] = useState([]);
  const userProfile = user && user.allowedModules ? user : { allowedModules: [] };
  
  useEffect(() => {
    if (!userProfile?.allowedModules) return; // Prevent execution if undefined
    if (
      Object.keys(userProfile).length > 0 &&
      typeof userProfile != "undefined" &&
      userProfile != null &&
      typeof userProfile.allowedModules != "undefined" &&
      userProfile.allowedModules.length <= 0
    ) {
      userProfile.allowedModules.push({
        value: "dashboard",
        operations: ["menu"],
      });
    }

    const filteredList = MenuList.filter((menu) => {
      const module = userProfile?.allowedModules?.find(
        (mod) => mod.value === menu.eventKey
      );
    
      if (!module || !module.operations.includes("menu")) return false;
    
      if (menu.mainArray) {
        menu.mainArray = menu.mainArray.filter((subMenu) =>
          userProfile?.allowedModules?.some(
            (mod) =>
              mod.value.trim() === subMenu.eventKey.trim() &&
              mod.operations.includes("menu")
          )
        );
      }
    
      if (menu.content) {
        menu.content = menu.content.filter((subMenu) =>
          userProfile?.allowedModules?.some(
            (mod) =>
              mod.value.trim() === subMenu.eventKey.trim() &&
              mod.operations.includes("menu")
          )
        );
      }
    
      return true;
    });
    

    setFilteredMenuList(filteredList);
  }, []);
  const handleMenuActive = (status) => {
    setMenustate({ active: status });
    if (menustate.active === status) {
      setMenustate({ active: "" });
    }
  };

  const handleSubmenuActive = (status) => {
    setMenustate({ activeSubmenu: status });
    if (menustate.activeSubmenu === status) {
      setMenustate({ activeSubmenu: "" });
    }
  };

  const setPath = (path) => {
    navigate(path);
  };

  function handleMenuOpen(ind) {
    if (ind === closeSidebar) {
      setOpenSidebar(!openSidebar);
    }
  }

  return (
    userProfile && filteredMenuList.length > 0 && (
      <Fragment>
        <NavHeader openSidebar={openSidebar} />
        <Tab.Container defaultActiveKey={"dashboard"}>
          <div className={`fixed-content-box ${openSidebar ? "active" : ""}`}>
            <div className="head-name">
              E-FORM
              <span
                className="close-fixed-content fa-left d-lg-none"
                onClick={() => setOpenSidebar(false)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                >
                  <g
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                  >
                    <polygon points="0 0 24 0 24 24 0 24" />
                    <rect
                      fill="#000000"
                      opacity="0.3"
                      transform="translate(15.000000, 12.000000) scale(-1, 1) rotate(-90.000000) translate(-15.000000, -12.000000) "
                      x="14"
                      y="7"
                      width="2"
                      height="10"
                      rx="1"
                    />
                    <path
                      d="M3.7071045,15.7071045 C3.3165802,16.0976288 2.68341522,16.0976288 2.29289093,15.7071045 C1.90236664,15.3165802 1.90236664,14.6834152 2.29289093,14.2928909 L8.29289093,8.29289093 C8.67146987,7.914312 9.28105631,7.90106637 9.67572234,8.26284357 L15.6757223,13.7628436 C16.0828413,14.136036 16.1103443,14.7686034 15.7371519,15.1757223 C15.3639594,15.5828413 14.7313921,15.6103443 14.3242731,15.2371519 L9.03007346,10.3841355 L3.7071045,15.7071045 Z"
                      fill="#000000"
                      fillRule="nonzero"
                      transform="translate(9.000001, 11.999997) scale(-1, -1) rotate(90.000000) translate(-9.000001, -11.999997) "
                    />
                  </g>
                </svg>
              </span>
            </div>
            <div
              className="fixed-content-body dz-scroll"
              id="DZ_W_Fixed_Contant"
            >
              <Tab.Content>
                {filteredMenuList[activeMenu].classStyle !== "blank" ? (
                  <div className="tab-pane show active">
                    <ul className="metismenu tab-nav-menu">
                      <>
                        {filteredMenuList[activeMenu].name === "doubleArray" ? (
                          <>
                            <li className="nav-label">
                              {filteredMenuList[activeMenu].title}
                            </li>
                            {filteredMenuList[activeMenu].mainArray.map(
                              (item, ind) => (
                                <li
                                  key={ind}
                                  className={`${
                                    item.title === menustate.active
                                      ? "mm-active"
                                      : ""
                                  }`}
                                >
                                  <Link
                                    to={"#"}
                                    className="has-arrow"
                                    onClick={() => {
                                      handleMenuActive(item.title);
                                    }}
                                  >
                                    {item.iconStyle}
                                    <span className="nav-text">
                                      {item.title}
                                    </span>
                                  </Link>
                                  <Collapse
                                    in={
                                      menustate.active === item.title
                                        ? true
                                        : false
                                    }
                                  >
                                    <ul>
                                      {item?.content?.map((data, ind) => {
                                        if (data.metisMenu === "has-menu") {
                                          return (
                                            <li key={ind}>
                                              <Link
                                                to={"#"}
                                                className="has-arrow"
                                                onClick={() => {
                                                  handleSubmenuActive(
                                                    data.title
                                                  );
                                                }}
                                              >
                                                {data.title}
                                              </Link>
                                              <Collapse
                                                in={
                                                  menustate.activeSubmenu ===
                                                  data.title
                                                    ? true
                                                    : false
                                                }
                                              >
                                                <ul>
                                                  {data?.content?.map(
                                                    (data, ind) => (
                                                      <li key={ind}>
                                                        <Link to={data.to}>
                                                          {data.title}
                                                        </Link>
                                                      </li>
                                                    )
                                                  )}
                                                </ul>
                                              </Collapse>
                                            </li>
                                          );
                                        } else {
                                          return (
                                            <li key={ind}>
                                              <Link to={data.to}>
                                                {data.title}
                                              </Link>
                                            </li>
                                          );
                                        }
                                      })}
                                    </ul>
                                  </Collapse>
                                </li>
                              )
                            )}
                          </>
                        ) : (
                          <>
                            {typeof filteredMenuList[activeMenu]?.content !=
                            "undefined" ? (
                              <>
                                <li className="nav-label">
                                  {filteredMenuList[activeMenu].title}
                                </li>
                                <li
                                  className={`${
                                    state.collpase1 ? "mm-active" : ""
                                  }`}
                                >
                                  <Link
                                    to={"#"}
                                    className="has-arrow"
                                    onClick={() =>
                                      dispatch({ type: "collpase1" })
                                    }
                                  >
                                    {filteredMenuList[activeMenu]?.iconStyle}{" "}
                                    <span className="nav-text">
                                      {filteredMenuList[activeMenu]?.title}
                                    </span>
                                    {/* <span className="badge badge-xs badge-light">10</span> */}
                                  </Link>
                                  <Collapse in={state.collpase1}>
                                    <ul>
                                      {filteredMenuList[
                                        activeMenu
                                      ]?.content.map((data, ind) =>
                                        userProfile &&
                                        userProfile != null &&
                                        userProfile.allowedModules &&
                                        userProfile.allowedModules.some(
                                          (module) =>
                                            module.value.toLowerCase() ===
                                            data?.to.toLowerCase()
                                        ) ? (
                                          <li key={ind}>
                                            <Link to={data?.to}>
                                              {data?.title}
                                            </Link>
                                            <ul>
                                              {data?.content?.map((item, i) => (
                                                <li key={i}>
                                                  <Link to={item.to}>
                                                    {item.title}
                                                  </Link>
                                                </li>
                                              ))}
                                            </ul>
                                          </li>
                                        ) : (
                                          ""
                                        )
                                      )}
                                    </ul>
                                  </Collapse>
                                </li>
                              </>
                            ) : (
                              <>
                                <li className="nav-label">
                                  <Link to={filteredMenuList[activeMenu]?.to}>
                                    <strong>
                                      {filteredMenuList[activeMenu]?.title}
                                    </strong>
                                  </Link>
                                </li>
                              </>
                            )}
                          </>
                        )}
                      </>
                    </ul>
                  </div>
                ) : (
                  ""
                )}
              </Tab.Content>
            </div>
          </div>
          <Header
            onProfile={() => onClick("profile")}
            toggle={toggle}
            title={title}
          />
          {/* <SideBar /> */}
          <div className="deznav">
            <div className="deznav-scroll">
              <Nav as="ul" className="nav menu-tabs">
                {filteredMenuList.map((item, index) => (
                  <Nav.Item
                    as="li"
                    key={index}
                    onClick={() => {
                      setOpenSidebar(true);
                      handleMenuOpen(index);
                      setCloseSidebar(index);
                      setPath(item.to || "/");
                    }}
                  >
                    <Nav.Link
                      className="ai-icon"
                      eventKey={item.eventKey}
                      title={item.title} // <-- Add the title attribute here
                      onClick={() => {
                        setActiveMenu(index);
                      }}
                    >
                      {item.iconStyle}
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
            </div>
          </div>
        </Tab.Container>
      </Fragment>
    )
  );
};

export default Deflayout;
